import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from './../reducers';
import apiMiddleware from './../middleware/api';
import Config from './../services/config';

import promise from 'redux-promise';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

export default function configureStore(preloadedState) {
	let state = {};

	const middlewares = [apiMiddleware(Config.serverPath), thunk, promise, logger];

	const middlewareEnhancer = applyMiddleware(...middlewares);

	const enhancers = [middlewareEnhancer];

	const composedEnhancers = compose(...enhancers);

	return createStore(rootReducer, state, preloadedState, composedEnhancers);
}
